import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareGoogleClassroomDirective } from './share-google-classroom.directive';


/** 分享到 google classroom api 工具模組 */
@NgModule({
  declarations: [ShareGoogleClassroomDirective],
  imports: [
    CommonModule
  ],
  exports: [
    ShareGoogleClassroomDirective,
  ]
})
export class GoogleClassroomModule { }
